import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject, Subject, debounceTime, distinctUntilChanged, map, startWith } from 'rxjs';
import { MyTeamModel } from 'src/app/models/common/myteam-model';
import { USER_ROLE_TYPE_EXTERNAL, USER_ROLE_TYPE_INTERNAL } from 'src/app/models/common/user-role';
import { ApiRoutes } from 'src/app/services/apiroutes';
import { AuthService } from 'src/app/services/auth.service';
import { UserMasterApiService } from 'src/app/services/domain_code/user-master-api.service';
import { environment } from 'src/environments/environment';
import { InviteMember } from './invite-member.model';
import { MyTeamService } from './my-team.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProfileRole } from 'src/app/models/profile-role';
import { WarningBoxComponent } from '../../dialog-box/warning-box/warning-box.component';
import { MatDialog } from '@angular/material/dialog';
import { BanUserComponent } from '../../snackbars/ban-user/ban-user.component';
import { UserRejectionReasonComponent } from './user-rejection-reason/user-rejection-reason.component';
import { ExternalMyTeamModel } from '../../master-data/user-form-external/external-my-team.model';

@Component({
    selector: 'my-team',
    templateUrl: './my-team.component.html',
    styleUrls: ['./my-team.component.scss']
})

export class MyTeamComponent implements OnInit {
    base_url = environment.baseApiUrl;
    pageSizeOptions: number[] = [5, 10, 25, 100];
    pageLength = 0;
    pageSize = 10;
    pageIndex = 0;
    searchTerm = '';
    myTeamList: MatTableDataSource<MyTeamModel>;
    responseDataInternal: MatTableDataSource<MyTeamModel>;
    myExternalTeamList: MatTableDataSource<ExternalMyTeamModel>;
    responseDataExternal: MatTableDataSource<ExternalMyTeamModel>;
    Canvas: string = "Canvas";
    Open: string = "sidepanel";
    searchText = new BehaviorSubject<string>('');
    isCustomer: boolean;
    showInvite: boolean = false;
    disableInviteButton: boolean = false;
    role_url = `${ApiRoutes.Company}profile_role/?type=${USER_ROLE_TYPE_EXTERNAL}&search=::search::`;
    commonError;
    currentUser;
    currentSearchTerm: string;
    defaultRole: ProfileRole;

    inviteObj: Array<InviteMember>;

    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;

    displayedColumns: string[] = ['name', 'created_at', 'last_login', 'action'];

    @Output()
    canvas = new EventEmitter<string>();

    @Output()
    open = new EventEmitter<string>();

    @Output()
    patchUserForm = new EventEmitter();

    @Output()
    patchExternalUserForm = new EventEmitter<ExternalMyTeamModel>();

    @Output()
    viewUserForm = new EventEmitter();

    defaultErrorObj: any = {};

    @Output()
    clearErrorsOnFormOpen = new EventEmitter();

    @Input()
    forceRefreshMyTeamList = new Subject();

    activeInactiveToggle: boolean = false;

    constructor(private userService: UserMasterApiService,
        private authService: AuthService,
        private myTeamService: MyTeamService,
        private snackBar: MatSnackBar,
        private dialog: MatDialog
    ) { }

    ngOnInit() {
        this.currentUser = this.authService.getUserProfile();
        this.isCustomer = this.authService.isCustomer();
        if (this.isCustomer) {
            this.getDefaultRole();
            this.displayedColumns = ['name', 'role', 'created_at', 'last_login', 'approval_status', 'action'];
            this.refreshExternalMyTeamData();
        } else {
            this.displayedColumns = ['name', 'created_at', 'last_login', 'action'];
            this.refreshMyTeamData();
        }
        this.forceRefreshMyTeamList.subscribe(item => {
            console.log(item)
            if (this.isCustomer) {
                this.refreshExternalMyTeamData();
            } else {
                this.refreshMyTeamData();
            }
        });

        this.searchText.pipe(
            startWith(''),
            debounceTime(500),
            map((searchText) => {
                if (this.isCustomer) {
                    this.refreshExternalMyTeamData(this.pageSize, this.pageIndex, searchText);
                } else {
                    this.refreshMyTeamData(this.pageSize, this.pageIndex, searchText);
                }
            })
        ).subscribe();
    }

    getDefaultRole() {
        this.myTeamService.getRole().subscribe({
            next: res => {
                for (let i = 0; i < res.results.length; i++) {
                    if (res.results[i].name == 'Employee') {
                        this.inviteObj = [new InviteMember(res.results[i])]
                        this.defaultRole = res.results[i]
                    }
                }
            }
        })
    }

    inviteMember() {
        if (this.isCustomer) {
            this.showInvite = true;
            this.disableInviteButton = false;
        } else {
            this.openUserSidePanel();
        }
    }

    openUserSidePanel() {
        this.clearErrorsOnFormOpen.emit(this.defaultErrorObj = {})
        // if(window.screen.width<=481){
        //     console.log(window.screen.width,'375px')
        //     document.getElementById("mySidepanel")!.style.width = "375px";
        // }else {
        //     console.log(window.screen.width,'493px')
        //     document.getElementById("mySidepanel")!.style.width = "493px";
        // }
        // document.getElementById("mySidepanel")!.style.width = "493px";
        // document.getElementById("mySidepanel")!.style.boxShadow = "0 0 0 99999px rgba(0, 0, 0, .5)";
        this.Canvas = " Canvas setCanvas";
        this.Open = " sidepanel slidepanelOpen ";
        this.open.emit(this.Open);
        this.canvas.emit(this.Canvas);
    }

    announceSortChange(sortState: Sort) {
        if (this.isCustomer) {
            switch (sortState.direction) {
                case 'asc':
                    if (sortState.active == 'name') {
                        this.refreshExternalMyTeamData(this.pageSize, this.pageIndex, '', `first_${sortState.active}`);
                    } else {
                        this.refreshExternalMyTeamData(this.pageSize, this.pageIndex, '', sortState.active);
                    }
                    break;

                case 'desc':
                    if (sortState.active == 'name') {
                        this.refreshExternalMyTeamData(this.pageSize, this.pageIndex, '', `-first_${sortState.active}`);
                    } else {
                        this.refreshExternalMyTeamData(this.pageSize, this.pageIndex, '', `-${sortState.active}`);
                    }
                    break;

                default:
                    this.refreshExternalMyTeamData(this.pageSize, this.pageIndex);
            }
        } else {
            switch (sortState.direction) {
                case 'asc':
                    if (sortState.active == 'name') {
                        this.refreshMyTeamData(this.pageSize, this.pageIndex, '', `first_${sortState.active}`);
                    } else {
                        this.refreshMyTeamData(this.pageSize, this.pageIndex, '', sortState.active);
                    }
                    break;

                case 'desc':
                    if (sortState.active == 'name') {
                        this.refreshMyTeamData(this.pageSize, this.pageIndex, '', `-first_${sortState.active}`);
                    } else {
                        this.refreshMyTeamData(this.pageSize, this.pageIndex, '', `-${sortState.active}`);
                    }
                    break;

                default:
                    this.refreshMyTeamData(this.pageSize, this.pageIndex);
            }
        }
    }

    applyFilter(event) {
        this.pageIndex = 0;
        this.searchText.next(event);
        this.filterActiveInactive();
    }

    refreshMyTeamData(pageSize = null, pageIndex = null, searchTerm = '', ordering = '') {
        pageSize = pageSize || this.pageSize;
        pageIndex = pageIndex || this.pageIndex;
        this.userService.getMyTeam(pageSize, pageIndex + 1, searchTerm, ordering).subscribe({
            next: response => {
                this.myTeamList = new MatTableDataSource(response.results);
                this.responseDataInternal = new MatTableDataSource(response.results);
                this.pageLength = response.count;
                this.filterActiveInactive();
            },
            error: error => {
                console.log("User table list error", error)
                return error;
            }
        });
    }

    refreshExternalMyTeamData(pageSize = null, pageIndex = null, searchTerm = '', ordering = '') {
        pageSize = pageSize || this.pageSize;
        pageIndex = pageIndex || this.pageIndex;
        this.userService.getExternalMyTeam(pageSize, pageIndex + 1, searchTerm, ordering).subscribe({
            next: response => {
                this.myExternalTeamList = new MatTableDataSource(response.results);
                this.responseDataExternal = new MatTableDataSource(response.results);
                this.pageLength = response.count;
                this.filterActiveInactive();
            },
            error: error => {
                console.log("User table list error", error)
                return error;
            }
        });
    }

    pageChanged(event: PageEvent) {
        this.pageSize = event.pageSize;
        this.pageIndex = event.pageIndex;
        if (this.isCustomer) {
            this.refreshExternalMyTeamData(this.pageSize, this.pageIndex);
        } else {
            this.refreshMyTeamData(this.pageSize, this.pageIndex);
        }
    }

    editUser(user) {
        this.openUserSidePanel()
        this.patchUserForm.emit(user)
        this.viewUserForm.emit(true);
    }

    viewUser(user) {
        this.openUserSidePanel()
        this.patchUserForm.emit(user);
        this.viewUserForm.emit(false);
    }

    editExternalUser(user: ExternalMyTeamModel) {
        this.openUserSidePanel();
        this.patchExternalUserForm.emit(user)
        this.viewUserForm.emit(true);
    }

    viewExternalUser(user: ExternalMyTeamModel) {
        this.openUserSidePanel()
        this.patchExternalUserForm.emit(user)
        this.viewUserForm.emit(false);
    }

    addMember() {
        this.inviteObj.push(new InviteMember(this.defaultRole));
    }

    removeMember(idx) {
        this.inviteObj.splice(idx, 1);
    }

    skipInvite() {
        this.inviteObj = [new InviteMember(this.defaultRole)];
        this.showInvite = false;
    }

    sendInvitation() {
        this.disableInviteButton = true;
        let data = []
        for (let i = 0; i < this.inviteObj.length; i++) {
            if (!this.inviteObj[i].isInviteDataValid()) {
                if (i == this.inviteObj.length - 1) {
                    this.disableInviteButton = false;
                    return;
                }
            } else {
                data[i] = this.inviteObj[i].getInvitePayload();
            }
        }

        this.myTeamService.postInviteEmails({ external_invite: data }).subscribe({
            next: res => {
                this.snackBar.open("Invitation sent successfully", 'Close', {
                    verticalPosition: 'top',
                    duration: 3000,
                });
                this.showInvite = false;
                this.inviteObj = [new InviteMember(this.defaultRole)];
                this.refreshExternalMyTeamData();
                return res;
            },
            error: err => {
                this.commonError = { ...err.error }
                for (let i = 0; i < this.inviteObj.length; i++) {
                    if (err.error.external_invite?.length) {
                        this.inviteObj[i].error = { ...err.error.external_invite[i] }
                    }
                }
                this.disableInviteButton = false;
                return err;
            }
        });
    }

    approveUser(user, convert_leads) {
        this.myTeamService.approveTeamMember({ email: user.user == null ? user.email : user.user.email, convert_leads: convert_leads }).subscribe({
            next: res => {
                this.snackBar.open("Approval sent", 'Close', {
                    verticalPosition: 'top',
                    duration: 3000,
                });
                this.refreshExternalMyTeamData();
            },
            error: err => {
                this.snackBar.open("Approval failed, try after some time", 'Close', {
                    verticalPosition: 'top',
                    duration: 3000,
                });
            }
        })
    }

    banUser(user, toBan: boolean) {
        let data = { user_id: user.user.id, is_banned: toBan };
        this.myTeamService.banUser(data).subscribe({
            next: response => {
                this.snackBar.openFromComponent(BanUserComponent, {
                    duration: 4000,
                    panelClass: ['success-snackbar'],
                    data: {
                        description: `${data.is_banned == true ? 'User is BANNED successfully' : 'Ban has been REVOKED'}`,
                        image: `${data.is_banned == true ? '/assets/images/icons/snackbar/ban-user1.svg' : '/assets/images/icons/snackbar/active-user.svg'}`
                    }
                });
                this.refreshExternalMyTeamData();
                return response;
            },
            error: error => {
                this.snackBar.open(error.error.user_id[0], 'Close', {
                    verticalPosition: 'top',
                    duration: 3000,
                });
                return error;
            }
        });
    }

    uninviteUser(user) {
        this.myTeamService.uninviteUser(user.id).subscribe({
            next: res => {
                this.snackBar.open("User Invitation has been revoked", 'Close', {
                    verticalPosition: 'top',
                    duration: 3000,
                });
                this.refreshExternalMyTeamData();
            },
            error: err => {
                this.snackBar.open("You cannot perform this action. Please contact Administrator", 'Close', {
                    verticalPosition: 'top',
                    duration: 3000,
                });
            }
        })
    }

    openConfirmDialog(type, user) {
        switch (type) {
            case 'uninvite':
                this.openWarningDialog(type, user, 'You are about to cancel the invite.', 'Are you sure you want to continue?', 'No', 'Yes'); break;
            case 'approve':
                let msg1 = `Are you sure you want to continue?`
                let btn1 = `Approve`
                let btn2 = ``
                if (user.unrealized_leads > 0) {
                    msg1 = `This user has added ${user.unrealized_leads} Requests(s). Do you want to import those requests to the portal as well?`
                    btn1 = ``
                    btn2 = `Approve and Import`
                }
                this.openWarningDialog(type, user, `You are about to approve login request of ${user.first_name} ${user.last_name}. He/She would be able to access business-related information.`, msg1, 'Go back', btn1, btn2);
                break;
            case 'reject':
                this.openRejectDialog(user); break;
            case 'ban':
                this.openWarningDialog(type, user, 'You are about to ban the user.', 'Are you sure you want to continue?', 'No', 'Yes'); break;
            case 'unban':
                this.openWarningDialog(type, user, 'You are about to unban the user.', 'Are you sure you want to continue?', 'No', 'Yes'); break;
        }
    }

    openWarningDialog(type, payload, label: string, description, action1: string, action2?: string, action3: string = null) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: { subTitle: label, parent: this, description: description, label1: action1, label2: action2, label3: action3, supportTextForlabel3: 'convert_leads_on_approval' }
        });

        dialogRef.afterClosed().subscribe(item => {
            if (item == 'convert_leads_on_approval') {
                this.approveUser(payload, true);
                return;
            }
            if (item) {
                switch (type) {
                    case 'uninvite':
                        this.uninviteUser(payload); break;
                    case 'approve':
                        this.approveUser(payload, false); break;
                    case 'ban':
                        this.banUser(payload, true); break;
                    case 'unban':
                        this.banUser(payload, false); break;
                }
            } else {
                return;
            }
        })
    }

    filterActiveInactive() {
        if (!this.activeInactiveToggle) {
            if (this.isCustomer)
                this.myExternalTeamList.data = this.responseDataExternal.data.filter(item => item?.is_active == true);
            else
                this.myTeamList.data = this.responseDataInternal.data.filter(item => item?.is_active == true);
        }
        else {
            if (this.isCustomer)
                this.myExternalTeamList.data = this.responseDataExternal.data;
            else
                this.myTeamList.data = this.responseDataInternal.data;

        }
    }

    openRejectDialog(user): void {
        const dialogData = {
            email: user.user == null ? user.email : user.user.email
        };
        const dialogRef = this.dialog.open(UserRejectionReasonComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: dialogData
        });

        // Optionally, you can subscribe to dialog close events
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                // Handle "Yes" button click
                console.log('User clicked Yes');
            } else {
                // Handle "No" button click or dialog close
                // console.log('User clicked No or closed the dialog');
            }
        });

        dialogRef.componentInstance.rejectReasonSaved.subscribe(() => {
            this.refreshExternalMyTeamData();
            this.snackBar.open("User Rejected!", 'Close', {
                verticalPosition: 'top',
                duration: 2000,
            });
        });
    }
}
